import * as type from './constants';

export const setIsLoading = isLoading => ({
  type: type.SET_IS_LOADING,
  isLoading
});

export const setSchedulingOthers = data => ({
  type: type.SET_SCHEDULING_OTHERS,
  data
});

export const clearSchedulingOthers = () => ({
  type: type.CLEAR_SCHEDULING_OTHERS
});